<template>
    <div class="distributionManageIndex flex_v">
        <!-- 分销管理 -->
        <!-- 标题 -->
        <div class="titleBox flex-row ite-c">
            <b>{{topTitle.title}}</b>
            <span v-show="topTitle.subTit!==''">-{{topTitle.subTit}}</span>
            <span v-show="topTitle.thirdTit!==''">-{{topTitle.thirdTit}}</span>
        </div>



        <!-- 筛选框 -->
        <sr-filter class="searchBox" @search="handleSearch" @reset="handleReset">
            <template slot="otherCom">

                <el-form-item>
                    <el-input
                            v-model="searchForm.params.memberCode"
                            placeholder="输入会员账号"
                            @keyup.enter.native="handleSearch"
                            maxlength="25" size="medium" clearable
                    >
                    </el-input>
                </el-form-item>

                <el-form-item>
                    <el-input
                            v-model="searchForm.params.memberName"
                            placeholder="输入会员名称"
                            @keyup.enter.native="handleSearch"
                            maxlength="25" size="medium" clearable
                    >
                    </el-input>
                </el-form-item>

                <el-form-item>
                    <el-input
                            v-model="searchForm.params.configName"
                            placeholder="输入分销规则名称"
                            @keyup.enter.native="handleSearch"
                            maxlength="25" size="medium" clearable
                    >
                    </el-input>
                </el-form-item>

            </template>
        </sr-filter>


        <!-- 表格 -->
        <div class="botTable boxs tableTheadGray">
            <div class="tableTop">
                <span class="top_le">分销管理明细表</span>
            </div>

            <el-table :data="distributionManageList"
                      style="width: 100%;"
                      border
                      fit
                      highlight-current-row
                      tooltip-effect="dark"
            >
                <el-table-column label="会员账号" prop="member_code" min-width="200" header-align="left" align="left"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column label="会员名称" prop="member_name" min-width="150" header-align="left" align="left"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column label="当前分销规则" prop="config_name" min-width="280" header-align="left" align="left"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column label="对应分销类型" prop="rule_name" min-width="280" header-align="left" align="left"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column label="操作" fixed="right" width="160" header-align="center" align="center"
                                 show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-button @click="showChangeRulesDialog(scope)"
                                   class="greenText"
                                   icon="fa fa-pencil"
                                   type="text"
                                   title="变更规则">变更规则
                        </el-button>
                    </template>
                </el-table-column>

            </el-table>
            <div class="pageBox boxs">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                               :current-page="searchForm.current" :page-sizes="[10, 20, 30]"
                               :page-size="searchForm.size"
                               layout="total, sizes, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </div>
        </div>


        <!-- “变更规则”弹窗 -->
        <el-dialog width="660px" :title="dialogMap[dialogTitle]" :visible.sync="dialogFormVisible" @close="closeDialog" :before-close="beforeClose" :close-on-click-modal=false>
            <!-- 筛选框 -->
            <sr-filter class="searchBox" @search="handleSearch2" @reset="handleReset2">
                <template slot="otherCom">

                    <el-form-item>
                        <el-input
                                v-model="dialogForm.params.configName"
                                placeholder="输入分销名称"
                                @keyup.enter.native="handleSearch2"
                                maxlength="25" size="medium" clearable
                        >
                        </el-input>
                    </el-form-item>

                    <el-form-item>
                        <el-select 
                                v-model="dialogForm.params.ruleId" 
                                placeholder="选择分销类型"
                                clearable filterable size="medium"
                        >
                            <el-option 
                                    v-for="item in distributionTypeOptions" 
                                    :key="item.id" 
                                    :label="item.name"
                                    :value="item.id"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>

                </template>
            </sr-filter>

            <!-- 表格 -->
            <el-table :data="distributionRulesTableList"
                        ref="distributionRulesTable"
                        tooltip-effect="dark"
                        style="width: 100%"
                        class="tableTheadGray3"
                        max-height="385"
                        border
                        @select-all="selectAllChange"
                        @select="selectOneSel"
            >
                <!-- 这是列表前面的勾选框 -->
                <el-table-column type="selection" width="39"></el-table-column>

                <el-table-column label="分销名称" prop="config_name" min-width="400" header-align="left"
                                align="left" show-overflow-tooltip></el-table-column>
                <el-table-column label="分销类型" prop="rule_name" min-width="130" header-align="left"
                                align="left" show-overflow-tooltip></el-table-column>
            </el-table>
            <!-- 分页 -->
            <div class="pageBox2">
                <el-pagination :pager-count="5" @size-change="handleSizeChange2" @current-change="handleCurrentChange2" :current-page="dialogForm.current"
                            :page-sizes="[7, 20, 40]" :page-size="dialogForm.size" :total="total2" layout="total, sizes, prev, pager, next">
                </el-pagination>
            </div>

            <span slot="footer" class="dialog-footer flex-row jus-c">
                <button @click="beforeClose" class="butStyle cancelBtn">取 消</button>
                <button @click="validateDialogForm" class="butStyle submitBtn">确 定</button>
            </span>
        </el-dialog>


    </div>
</template>

<script>
    import SrFilter from '@/components/Common/Filter/Filter'
    import {
        getDistributionManageAPI, //查询分销管理列表
        getDistributionTypeMap, //获取分销类型
        getConfigListAPI, //查询分销配置规则列表
        changeRulesAPI, //变更规则
    } from '@/api/Operate/DistributionManage/distributionManage.js';

    // 查询弹窗表格（分销规则列表）的条件
    const defaultDialogForm = {
        params: {
            configName: '',// 分销规则名称
            ruleId: null,// 分销规则类型
            memberId: null,
        },
        current: 1, //当前页码
        size: 7, //每页条数
        sortDesc: 'checked', //排序方向 sortDesc降序、sortAsc升序
    }

    // 查询表格的条件
    const searchConst = {
        params: {
            memberCode: null,// 会员账号
            memberName: null,// 会员名称
            configName: null,// 分销规则名称
        },
        current: 1, //当前页码
        size: 10, //每页条数
    }

    export default {
        name: 'distributionManageIndex',
        data() {
            return {
                //标题
                topTitle: {
                    title: '分销管理',
                    subTit: '',
                    thirdTit: '',
                },
                // 当前登录会员信息
                memberInfo: null,

                // 表格搜索条件
                searchForm: Object.assign({}, searchConst),
                // 表格数据
                distributionManageList: [],
                // 表格数据总数
                total: 0,


                // 分销规则列表(弹窗内表格显示)
                distributionRulesTableList: [],
                // 变更规则弹窗-列表总数
                total2: 0,
                // 变更规则弹窗-勾选的规则数组
                dialogAddRulesArr: [],
                // 变更规则弹窗-取消勾选的规则数组
                dialogDelRulesArr: [],
                // “变更规则”弹窗数据
                dialogForm: Object.assign({}, defaultDialogForm),
                // 变更规则窗口是否显示
                dialogFormVisible: false,
                // 弹窗标题
                dialogMap: {
                    changeRules: '变更规则',
                },
                dialogTitle: '',
                // 分销类型
                distributionTypeOptions: [],
            }
        },
        components: {
            SrFilter
        },
        computed: {},
        created() {
            // 查询分销管理列表
            this.getDistributionManageList();

        },
        methods: {
            // 查询分销管理列表
            async getDistributionManageList() {
                try {
                    const result = await getDistributionManageAPI(this.searchForm);
                    this.distributionManageList = result.data.records;
                    this.total = result.data.total;
                } catch (e) {
                    console.log(e)
                }
            },
            // 列表过滤查询
            handleSearch() {
                // 查询分销管理列表
                this.getDistributionManageList();
            },
            // 搜索重置（清空）
            handleReset() {
                // 初始化参数
                this.searchForm.params.memberCode = ''
                this.searchForm.params.memberName = ''
                this.searchForm.params.configName = ''
                this.searchForm.current = 1
                this.searchForm.size = 10
                this.handleSearch()
            },
            // 列表每页条数变了
            handleSizeChange(val) {
                this.searchForm.size = val
                this.handleSearch()
            },
            // 列表当前页码变了
            handleCurrentChange(val) {
                this.searchForm.current = val
                this.handleSearch()
            },

            


            // 显示“变更规则”弹窗
            showChangeRulesDialog(data) {
                this.dialogTitle = 'changeRules'
                this.dialogFormVisible = true

                const rowDate = JSON.parse(JSON.stringify(data.row));
                this.dialogForm.params.memberId = rowDate.member_id;

                // 分销类型下拉框
                this.initDistributionTypeOptions()
                // 获取分销规则列表(弹窗显示)
                this.getDistributionRulesList()
            },
            // 获取分销类型
            async initDistributionTypeOptions() {
                try {
                    const result = await getDistributionTypeMap();
                    this.distributionTypeOptions = result.data;
                } catch (e) {
                    console.log(e)
                }
            },
            // 获取分销规则列表(弹窗显示)
            async getDistributionRulesList() {
                try {
                    const result = await getConfigListAPI(this.dialogForm);
                    this.distributionRulesTableList = result.data.records;
                    this.total2 = result.data.total;

                    // 当前需要显示勾选的数据组成的数组
                    let checkedGouArr = []
                    
                    // 遍历表格数组
                    this.distributionRulesTableList.forEach((item,itemIndex) => {
                        // 如果表格数组中某一项的id值存在于“弹窗勾选id数组”中
                        if(item.checked == 1) {
                            checkedGouArr.push(item)
                        }
                    })
                    

                    // 如果当前弹窗有用户当前操作的勾选数据
                    if(this.dialogAddRulesArr.length > 0) {
                        // 把勾选数据的id组成一个数组“弹窗勾选id数组”（用于显示勾选）
                        let addRulesIdArr = []
                        this.dialogAddRulesArr.filter((item) => {
                            addRulesIdArr.push(item.config_id)
                        })

                        // 遍历表格数组
                        this.distributionRulesTableList.forEach((item,itemIndex) => {
                            let currTableIndex = addRulesIdArr.indexOf(item.config_id);
                            // 如果表格数组中某一项的id值存在于“弹窗勾选id数组”中
                            if(currTableIndex != -1) {
                                // 把当前项加入回显勾选数组
                                checkedGouArr.push(item)
                            }
                        })
                    }

                    // 如果当前弹窗有用户当前操作的取消勾选数据
                    if(this.dialogDelRulesArr.length > 0) {
                        // 把取消勾选数据的id组成一个数组“弹窗取消勾选id数组”（用于显示勾选）
                        let delRulesIdArr = []
                        this.dialogDelRulesArr.filter((item) => {
                            delRulesIdArr.push(item.config_id)
                        })

                        // 遍历表格数组
                        this.distributionRulesTableList.forEach((item,itemIndex) => {
                            let currTableIndex = delRulesIdArr.indexOf(item.config_id);
                            // 如果表格数组中某一项的id值存在于“弹窗取消勾选id数组”中
                            if(currTableIndex != -1) {
                                let spliceIndex = checkedGouArr.indexOf(item);
                                // 而且表格数组中某一项存在于“用户当前操作弹窗的勾选数组”中
                                if(spliceIndex != -1) {
                                    let spliceIndex = JSON.stringify(checkedGouArr).indexOf(JSON.stringify(item));
                                    // 把当前项移出回显勾选数组
                                    checkedGouArr.splice(spliceIndex, 1)
                                }
                            }
                        })
                    }

                    // 显示勾选(勾选表格行事件)
                    this.$nextTick(() => {
                        this.toggleSelection(checkedGouArr)
                    })

                } catch (e) {
                    console.log(e)
                }
            },
            // 显示勾选表格行事件
            toggleSelection(rows) {
                if (rows) {
                    // console.log('rows.length', rows.length)
                    rows.forEach(row => {
                        this.$refs.distributionRulesTable.toggleRowSelection(row, true);
                    });
                } else {
                    this.$refs.distributionRulesTable.clearSelection();
                }
            },
            // 规则列表每页条数变了
            handleSizeChange2 (val) {
                this.dialogForm.size = val
                this.getDistributionRulesList()
            },
            // 规则列表当前页码变了
            handleCurrentChange2 (val) {
                this.dialogForm.current = val
                this.getDistributionRulesList()
            },
            // 规则列表列表过滤查询
            handleSearch2 () {
                this.dialogForm.current = 1
                this.getDistributionRulesList()
            },
            // 规则列表搜索重置（清空）
            handleReset2 () {
                this.dialogForm.current = 1
                this.dialogForm.size = 7
                this.dialogForm.params.configName = null
                this.dialogForm.params.ruleId = null
                this.getDistributionRulesList()
            },
            // 弹窗关闭前
            beforeClose () {
                this.resetData()
            },
            // 关闭弹窗
            closeDialog () {
                this.resetData()
            },
            // 重置弹窗数据
            resetData () {
                this.dialogFormVisible = false
                // 重置查询数据
                // this.dialogForm = Object.assign({}, defaultDialogForm)
                this.dialogForm.current = 1
                this.dialogForm.size = 7
                this.dialogForm.params.configName = null
                this.dialogForm.params.ruleId = null
                // 重置勾选数据
                this.dialogAddRulesArr = []
                this.dialogDelRulesArr = []
            },
            // 验证弹窗数据
            validateDialogForm () {
                if (this.dialogAddRulesArr.length <= 0 && this.dialogDelRulesArr.length <= 0) {
                    this.$message.warning('当前没有变更勾选的规则')
                    this.dialogFormVisible = true
                    return;
                }

                this.submitDialogForm()
            },
            // 提交弹窗数据
            submitDialogForm() {
                let changeParam = {};
                changeParam.memberId = this.dialogForm.params.memberId;
                changeParam.addArr = [];
                changeParam.delArr = [];

                // 把勾选的数据添加到addArr
                this.dialogAddRulesArr.forEach(item => {
                    let currId = {
                        ruleId: item.rule_id,
                        configId: item.config_id
                    }
                    changeParam.addArr.push(currId)
                })
                // 把取消勾选的数据添加到delArr
                this.dialogDelRulesArr.forEach(item => {
                    let currId = {
                        ruleId: item.rule_id,
                        configId: item.config_id
                    }
                    changeParam.delArr.push(currId)
                })

                changeRulesAPI(changeParam).then(resp => {
                    if (resp && resp.code != 0) {
                        this.$message.error(resp.msg)
                        return
                    }
                    this.$message.success('规则变更成功')
                    // 关闭弹窗
                    this.closeDialog();
                    // 重新获取页面列表
                    this.getDistributionManageList()
                }).catch(err => {
                    console.log(err)
                })
            },
            // 列表全勾选/全取消勾选
            selectAllChange(val) {
                let sels = val
                // console.log('selectAllChange-val', val)

                // 全勾选
                if(sels.length > 0) {
                    sels.forEach((item) => {
                        let rulesListIndex = JSON.stringify(this.dialogAddRulesArr).indexOf(JSON.stringify(item));
                        let rulesListIndex2 = JSON.stringify(this.dialogDelRulesArr).indexOf(JSON.stringify(item));
                        if(item.checked == 1) {
                        // if(rulesListIndex2 != -1 && item.checked == 1) {
                        // if(rulesListIndex2 != -1) {
                            // 只有当删除规则数组里面有该对象时才删除（避免报错）
                            this.dialogDelRulesArr.splice(rulesListIndex2, 1)
                        } else if(item.checked == 0) {
                            // 只有当添加规则数组里面没有该对象时才添加进去（避免重复）
                            this.dialogAddRulesArr.push(item)
                        }
                    })
                }
                // 全取消勾选
                else if (sels.length == 0) {
                    this.distributionRulesTableList.forEach((item) => {
                        let rulesListIndex = JSON.stringify(this.dialogAddRulesArr).indexOf(JSON.stringify(item));
                        let rulesListIndex2 = JSON.stringify(this.dialogDelRulesArr).indexOf(JSON.stringify(item));
                        if(rulesListIndex2 == -1 && item.checked == 1) {
                            // 只有当删除规则数组里面没有该对象、且查询结果是勾选状态时才添加进去（避免重复）
                            this.dialogDelRulesArr.push(item)
                        } else if(item.checked == 0) {
                            // // 只有当添加规则数组里面有该对象、且查询结果是未勾选状态时才删除（避免报错）
                            // 只有当查询结果是未勾选状态时才删除（避免报错）
                            this.dialogAddRulesArr.splice(rulesListIndex, 1)
                        }
                    })
                }

                // console.log('selectAllChange-dialogAddRulesArr', this.dialogAddRulesArr)
                // console.log('selectAllChange-dialogDelRulesArr', this.dialogDelRulesArr)

            },
            // 列表勾选/取消勾选(用户手动勾选数据行的 Checkbox 时触发的事件)
            selectOneSel(selection, row) {// selection：当前所有选中的数组，row：当前勾选变化的一行

                // console.log('selectOneSel-selection', selection)
                // console.log('selectOneSel-row', row)

                // 把勾选数据的id组成一个数组“弹窗勾选id数组”
                let addRulesIdArr = []
                this.dialogAddRulesArr.filter((item) => {
                    addRulesIdArr.push(item.config_id)
                })
                // 把取消勾选数据的id组成一个数组“弹窗取消勾选id数组”
                let delRulesIdArr = []
                this.dialogDelRulesArr.filter((item) => {
                    delRulesIdArr.push(item.config_id)
                })

                let fd = selection.indexOf(row)
                let fd1 = addRulesIdArr.indexOf(row.config_id)
                let fd2 = delRulesIdArr.indexOf(row.config_id)

                if(fd != -1){ // 如果是添加勾选操作
                    if(fd2 != -1) {
                        // 只有当删除规则数组里面有该对象时才删除（避免报错）
                        this.dialogDelRulesArr.splice(fd2, 1);
                    } else if(fd1 == -1) {
                        // 只有当添加规则数组里面没有该对象时才添加进去（避免重复）
                        this.dialogAddRulesArr.push(row);
                    }
                } else if(fd == -1){ // 如果是取消勾选操作
                    if(fd1 != -1) {
                        // 只有当添加规则数组里面有该对象时才删除（避免报错）
                        this.dialogAddRulesArr.splice(fd1, 1);
                    } else if(fd2 == -1) {
                        // 只有当删除规则数组里面没有该对象时才添加进去（避免重复）
                        this.dialogDelRulesArr.push(row);
                    }
                }

                // console.log('selectOneSel-dialogAddRulesArr', this.dialogAddRulesArr)
                // console.log('selectOneSel-dialogDelRulesArr', this.dialogDelRulesArr)
            },

        }
    }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>

.greenText {
    color: #2DBAA5;
}

.distributionManageIndex {
}

// 标题
.titleBox {
    width: 100%;
    background: #ffffff;
    height: 44px;
    padding: 0 9px;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
}

.titleBox b {
    color: #2B2727;
    font-size: 15px;
}

.titleBox span {
    color: #7F7F7F;
    font-size: 13px;
}

.titleBox .titRiImg {
    width: 76px;
    height: 24px;
}

// 列表顶部标题
.titleLine {
    width: 100%;
    height: 20px;
    margin-top: 12px;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
}

.titleLine span {
    height: 20px;
    line-height: 20px;
    font-size: 15px;
    font-weight: bold;
    color: #2B2727;
}

.titleLine span::before {
    content: '';
    display: inline-block;
    width: 5px;
    height: 20px;
    margin-right: 6px;
    background: #FA6241;
    vertical-align: middle;
}


.searchBox {
    margin-top: 1px;
}


// 表格
.botTable {
    margin-top: 12px;
    width: 100%;
    // max-height: 408px;
}

.botTable .tableTop {
    height: 54px;
    padding: 0 12px;
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    align-items: center;
    background-color: #ffffff;
    border: 1px solid #EEEEEE;
    border-bottom: none;
}

.botTable .tableTop .top_le {
    font-size: 15px;
    font-weight: bold;
    color: #4E4A46;
}

.botTable .tableTop .exportBtn {
    width: 72px;
    height: 30px;
    line-height: 30px;
    font-size: 13px;
    border-radius: 4px;

    &:hover {
        background-color: rgb(247, 143, 120);
    }
}

.botTable .tableTop .exportBtn .exportIcon {
    display: inline-block;
    width: 14px;
    height: 14px;
    background: url('../../../assets/images/busy/Finance/FinancialAudit/CashOutAudit/exportBtn.png') no-repeat;
    background-size: 14px 14px;
}

.greenBtn {
    width: 96px;
    height: 30px;
    line-height: 30px;
    font-size: 12px;
    border-radius: 4px;
    color: #ffffff;

    background-color: #2DBAA5;

    &:hover {
        background-color: rgb(115, 196, 183);
    }
}

/* 分页条 */
.pageBox {
    width: 100%;
    padding: 15px 0 10px;
    display: flex;
    justify-content: flex-end;
    background: #ffffff;
    border: 1px solid #E4E4E4;
    border-top: none;
    //   border-bottom-left-radius: 3px;
    //   border-bottom-right-radius: 3px;
}


// 弹窗按钮-取消按钮
.cancelBtn {
    width: 120px;
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    border-radius: 4px;
    background: #FFFFFF;
    color: #2B2727;
    color: #666666;
    border: 1px solid #EEEEEE;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;

    &:hover {
        // background-color: #f1f1f1;
        border: 1px solid #d1d0d0;
    }
}

// 弹窗按钮-橙色按钮
.submitBtn {
    width: 120px;
    height: 40px;
    line-height: 40px;
    margin-left: 20px;
    font-size: 14px;
    border-radius: 4px;
    background: #FA6241;
    color: #FFFFFF;

    &:hover {
        background-color: rgb(247, 143, 120);
    }
}

// 分页条2
.pageBox2 {
    // width: 498px;
    width: 100%;
    padding: 10px 0px;
    display: flex;
    justify-content: flex-end;
    background: #ffffff;
}
.pageBox2 .el-pagination {
    padding-right: 0px;
}


</style>
